import { defineAsyncComponent } from "vue";
import i18n from "../../../i18n";
import { required, same } from "../../../utils/validate";
import store from "../../../store";
import { validateError } from "../../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { createLoading } from "../../../utils/loading";
import lodash from "lodash";
import { callOtpGenertate } from "../../../components/verify-otp/verify-otp.logic";
import { notification } from "ant-design-vue";
import { createFieldInputPassword, createFieldInputNumber } from "../../../components/input/template-builder/template-builder.logic";
import router from "../../../router";

export const CIcon = defineAsyncComponent(() => import("../../../components/icon/CIcon"));
export const callEmailOtpGenertate = ({ form }) => store.dispatch(`resource/v1/security/emailToken/generate`, { data: form });
export const { isLoading, setIsLoading } = createLoading();

export const callGetForgotPasswordByKey = ({ data, key }) => {
    const { useForm } = data
    const { modelRef } = useForm
    return store.dispatch('resource/auth/getForgotPasswordByKey', { key, config: { isNotification: false } })
        .then((forgotPassword) => lodash.merge(modelRef.forgotPassword, forgotPassword))
        .catch((error) => {
            const message = error.response?.data?.message
            if (message) {
                data.errorMessage = i18n.global.t(message);
            }
        });
}

export const callActiveForgotPassword = ({ data, form }) => {
    const otpTemp = form.otp
    data.otp.otp = otpTemp
    const formPassword = lodash.cloneDeep(form);
    formPassword.otp = data.otp 
    return store
        .dispatch("resource/auth/activeForgotPasswordOtp", { data: formPassword, config: { isNotification: false } })
        .then(() => (data.success = true))
        .catch((error) => {
            const message = error.response?.data?.message;
            if (message) {
                data.errorMessage = i18n.global.t(message);
            }
        });
};

export const onClickResetForgotPassword = ({ data, refs }) => {
    const { useForm } = data;
    useForm
        .validate()
        .then(() => {
            data.success = false;
            data.buttonResetForgotPassword.disabled = true;
            return callActiveForgotPassword({ data, form: useForm.modelRef }).finally(() => (data.buttonResetForgotPassword.disabled = false));
        })
        .catch((error) => {
            validateError({ error, el: refs.form.$el });
        });
};

export const createForm = () => {
    return {
        forgotPassword: {
            id: null,
        },
        newPassword: null,
        confirmPassword: null,
    };
};

export const createRules = ({ data }) => {
    const { form } = data;
    return {
        newPassword: [required],
        confirmPassword: [
            required,
            same(form, "newPassword", i18n.global.t("views.changePassword.newPassword"), i18n.global.t("views.changePassword.confirmPassword")),
        ],
    };
};

export const createField = ({ props, data, refs }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const dirty = {};
    return [
        createFieldInputPassword({
            key: "newPassword",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            label: () => i18n.global.t("views.changePassword.newPassword"),
            inputProp: () => ({
                value: modelRef.newPassword,
                "onUpdate:value": (value) => (modelRef.newPassword = value),
                onBlur: () => {
                    if (dirty["confirmPassword"]) {
                        useForm.validate("confirmPassword").catch(() => {});
                    }
                    useForm.validate("newPassword").catch(() => {});
                },
                onKeyup: (e) => {
                    if (e.keyCode === 13) {
                        refs.confirmPassword.focus();
                    }
                },
            }),
        }),
        createFieldInputPassword({
            key: "confirmPassword",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            label: () => i18n.global.t("views.changePassword.confirmPassword"),
            inputProp: () => ({
                value: modelRef.confirmPassword,
                "onUpdate:value": (value) => (modelRef.confirmPassword = value),
                onBlur: () => {
                    dirty["confirmPassword"] = true;
                    useForm.validate("confirmPassword").catch(() => {});
                },
                ref: (e) => {
                    refs.confirmPassword = e;
                },
                onKeyup: (e) => {
                    if (e.keyCode === 13) {
                        onClickResetForgotPassword({ props, data, refs });
                    }
                },
            }),
        }),
        createFieldInputNumber({
            key: "otp",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            label: () => i18n.global.t("model.otp.otp"),
            inputProp: () =>
                lodash.merge({
                    value: modelRef.otp,
                    "onUpdate:value": (value) => (modelRef.otp = value),
                    comma: false,
                    maxDecimal: 6,
                }),
        }),
    ];
};

export const initForm = ({ props, data, refs }) => {
    const { form } = props;
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    const promise = callGetForgotPasswordByKey({ data, key: form?.userKey })
    promise.finally(() => setIsLoading(false))
    loadForm({ props, data, refs });
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true)
    const { form } = props;
    let promise = null;
    data.color="color:null"
    if ("mobile".includes(form?.refContact?.key)) {
        promise = callOtpGenertate({ form: form }).catch((error) => {
            if (error.response?.data.message === "error.v1OtpService.estimated") {
                data.isWaitApprove = true;
            }
            validateError({ error });
            throw error;
        });
    } else if ("email".includes(form?.refContact?.key)) {
        promise = callEmailOtpGenertate({ form: form }).catch((error) => {
            validateError({ error });
            throw error;
        });
    } else {
        notification["error"]({ message: i18n.global.t("model.securityEvent.error") });
        return router.push({ name: "forgot-password" });
    }

    return promise
        .then((otp) => (data.otp = otp))
        .then(() => {
            data.isGenOtp = false;
            data.timeGen = 180;
            const interval = setInterval(() => {
                data.timeGen--;
                if (data.timeGen < 1) {
                    data.isGenOtp = true;
                    clearInterval(interval);
                }
                if (data.timeGen < 79) {
                    data.color = "color:red"
                }
            }, 1000);
        }).finally(() => setIsLoading(false));
};

export const resend = ({ props, data, refs }) => {
    loadForm({ props, data, refs }).then(() => notification["success"]({ message: i18n.global.t("views.otp.resendSuccess") }));
};
